import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { API_CATALOG } from '../config/api-catalog.config';
import { ApiProfile } from '../models/api-profile.model';

@Injectable({ providedIn: 'root' })
export class ApiProfileService {
  private readonly activeProfileStorageKey = 'api_workspace_active_profile';
  private readonly profilesById = new Map(
    API_CATALOG.map((profile) => [profile.id, profile]),
  );
  private readonly activeProfileSubject = new BehaviorSubject<ApiProfile>(
    this.resolveInitialProfile(),
  );

  readonly profiles = API_CATALOG;
  readonly activeProfile$ = this.activeProfileSubject.asObservable();

  get activeProfile(): ApiProfile {
    return this.activeProfileSubject.value;
  }

  selectProfile(profileId: string): ApiProfile {
    const profile = this.getProfile(profileId);
    localStorage.setItem(this.activeProfileStorageKey, profile.id);
    this.activeProfileSubject.next(profile);
    return profile;
  }

  getProfile(profileId: string): ApiProfile {
    const profile = this.profilesById.get(profileId);

    if (profile === undefined) {
      throw new Error(`Không tìm thấy API profile: ${profileId}`);
    }

    return profile;
  }

  findProfileByRequestUrl(url: string): ApiProfile | null {
    return (
      this.profiles.find((profile) => url.startsWith(profile.baseUrl)) ?? null
    );
  }

  private resolveInitialProfile(): ApiProfile {
    const storedProfileId = localStorage.getItem(this.activeProfileStorageKey);
    return (
      (storedProfileId === null
        ? undefined
        : this.profilesById.get(storedProfileId)) ??
      API_CATALOG[0]
    );
  }
}
